export function isIpad(userAgent: string, platform: string, maxTouchPoints: number): boolean {
  return /iPad/.test(userAgent)
    || (platform === 'MacIntel' && maxTouchPoints > 1);
}

function isPhone(userAgent: string): boolean {
  return /iPhone|iPod|Android.*Mobile|Windows Phone/i.test(userAgent);
}

function isTablet(userAgent: string): boolean {
  return /Android(?!.*Mobile)|Tablet|Silk|Kindle|PlayBook/i.test(userAgent);
}

export function showCustomPreview(): boolean {
  const {
    userAgent,
    platform,
    maxTouchPoints,
  } = navigator;
  return isIpad(userAgent, platform, maxTouchPoints)
    || isPhone(userAgent)
    || isTablet(userAgent);
}
